import { useId, useRef } from 'react';
import { Modal } from '@/components/Modal';
import { PLAN_NAMES, UNIT_EXAMPLES, UNIT_PACKS, UNIT_ROWS } from '@/data/planTable';

function UnitTable() {
  return (
    <div className="relative overflow-x-auto px-5">
      <table className="modal-table">
        <caption className="sr-only">플랜별 Investigation Unit 구성과 단가</caption>
        <thead>
          <tr>
            <th scope="col" className="w-[200px]">
              <span className="sr-only">항목</span>
            </th>
            {PLAN_NAMES.map((name) => (
              <th key={name} scope="col">
                {name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {UNIT_ROWS.map((row) => (
            <tr key={row.label}>
              <th scope="row" className={row.bold ? 'font-bold' : undefined}>
                {row.label}
              </th>
              {row.cells.map((value, index) => (
                <td key={PLAN_NAMES[index]} className={row.bold ? 'font-bold' : undefined}>
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function UnitModal({ open, onClose, returnFocusRef }) {
  const titleRef = useRef(null);
  const titleId = useId();

  return (
    <Modal
      open={open}
      onClose={onClose}
      initialFocusRef={titleRef}
      returnFocusRef={returnFocusRef}
      className="unit-modal"
      aria-labelledby={titleId}
    >
      <div className="flex max-h-[88vh] flex-col gap-8 p-8 md:p-[60px]">
        <div className="shrink-0 flex flex-col gap-4">
          <div className="flex items-start justify-between">
            <img
              src="/assets/icons/unit-shield.svg"
              alt=""
              aria-hidden="true"
              width="44"
              height="44"
              className="h-11 w-11"
            />
            {/* data-modal-close: 태블릿 CSS 가 이 훅으로 아이콘 크기를 줄인다
                (styles/tablet.css → .unit-modal [data-modal-close] img) */}
            <button
              type="button"
              data-modal-close
              aria-label="닫기"
              className="cursor-pointer transition-opacity hover:opacity-70"
              onClick={onClose}
            >
              <img
                src="/assets/icons/icon-close.svg"
                alt=""
                aria-hidden="true"
                width="40"
                height="40"
                className="h-10 w-10"
              />
            </button>
          </div>

          {/* tabindex=-1 + Modal 의 initialFocusRef: showModal() 이 기본으로 첫 포커스
              가능 요소(닫기 X)에 포커스를 넣는 걸 막고 제목부터 읽히게 한다 */}
          <h2 id={titleId} ref={titleRef} className="section-title" tabIndex={-1}>
            Investigation Unit이란?
          </h2>
        </div>

        <div className="modal-card min-h-0 flex-1 overflow-y-auto">
          <h3 className="modal-section-title">1. Investigation Unit이란?</h3>

          <div className="modal-body">
            <p>
              <strong className="modal-strong">
                1 Investigation Unit = 1 investigation target Endpoint
              </strong>
              <br />
              Server 1대 또는 이에 준하는 하나의 조사 대상
            </p>
            <ul role="list">
              {UNIT_EXAMPLES.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>

          <UnitTable />

          <div className="modal-body">
            <p>
              <strong className="modal-strong">Professional 100 Units </strong>
              <br />
              월평균 약 8대로 자체 IR팀을 막 운영하기 시작한 기업, 중견기업 추천
            </p>
            <p>
              <strong className="modal-strong">Enterprise 300 Units</strong>
              <br /> 월평균 25대로 실제 사고가 발생했을 때 수십 대
              단위의 조사 가능.
              <br />
              평상시 조사에도 사용할 수 있어 일반 대기업 CSIRT/SOC에 적합
            </p>
            <p>
              <strong className="modal-strong">Enterprise Plus 1,000 Units</strong>
              <br /> 월평균 약 83대로 대기업이나 다수 계열사 운영 조직
              적합.
            </p>
          </div>

          <h3 className="modal-section-title">2. 초과 Unit 가격</h3>

          <div className="modal-body border-b border-line">
            <p>
              기본 3가지 플랜 외 추가 사용량이 필요할 경우{' '}
              <strong className="modal-strong">Unit Pack</strong> 구매 가능
              <br />
              <span className="modal-muted">
                ex) 100 Units 추가를 정가 기준 2,000만원 정도로 잡고 플랜별 할인율을 적용할
                수 있습니다.
              </span>
            </p>
            <ul role="list">
              {UNIT_PACKS.map((pack) => (
                <li key={pack.plan}>
                  {pack.plan}: {pack.amount}{' '}
                  <strong className="modal-strong">{pack.price}</strong>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Modal>
  );
}
